import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 67.088 51.84",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 67.088 51.84\" id=\"icon-share\">\n<g id=\"icon-share_share\">\n\t<path style=\"fill:#80807F;\" d=\"M37.088,14V0l30,22.57l-29.9,22.35V30.35c-17.45-1.55-29,6.63-37,21.49\n\t\tc-1.29-6.35,4.25-20.5,10.35-27.13C17.598,17.05,26.608,14.09,37.088,14z\" fill=\"currentColor\" />\n</g>\n<g id=\"icon-share_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol